import React, {FC, useEffect} from "react";
import Checkers from "../../../../helpers/class/Checkers";
import {faCheck as faCheck, faAngleRight as faAngleRight} from "@fortawesome/pro-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

interface FeaturesListProps {
    featureList: Array<any>|null
}
const FeaturesList: FC<FeaturesListProps> = ({featureList} ) => {

    return (
        <>
            {
                Checkers.isValidArray(featureList) && featureList.map( (featureGroup) => {
                    return (
                        <>
                            <div className="block-title p-b-15 text-black">
                                {featureGroup.group_title}&nbsp;<FontAwesomeIcon className="me-2" icon={faAngleRight}/>
                            </div>
                            <div className={'row m-b-20'}>
                                {
                                    featureGroup.features.map((feature) => {
                                        return (
                                            <>
                                                <div className={'col-md-6'}>
                                                    <FontAwesomeIcon className="me-2" icon={faCheck}/>
                                                    {feature.feature_title}&nbsp;
                                                    {
                                                        feature.feature_options != null && feature.feature_options.length > 0 ?
                                                            <>
                                                                <b>
                                                                    {feature.feature_options[0].option_value}
                                                                </b>
                                                            </>
                                                            :
                                                            <>
                                                                {
                                                                    feature.feature_value != "1" && feature.feature_value != 1 ?
                                                                        <>
                                                                            <b>
                                                                                {feature.feature_value}
                                                                            </b>
                                                                        </>
                                                                        :
                                                                        <>
                                                                        </>
                                                                }
                                                            </>
                                                    }
                                                </div>
                                            </>
                                        )
                                    })
                                }
                            </div>
                        </>
                    )
                })
            }
        </>
    )
}

export default FeaturesList